module.exports = __webpack_public_path__ + "font/c1a866ec.eot";